import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { SentimentReportsService } from './sentiment-reports.service';
import { ProjectsService } from 'app/_services/projects.service';
const moment = require('moment');

@Component({
  selector: 'app-sentiment-reports',
  templateUrl: './sentiment-reports.component.html',
  styleUrls: ['./sentiment-reports.component.scss']
})
export class SentimentReportsComponent implements OnInit {

  brandDropDownSettings: any;
  brandSelected = [];
  brandSelectedFilter = [];
  brands = [];
  notSpam2 = false;
  reportName = "";
  dataReport: Object;

  projectDropDownSettings: any;
  projectSelectedFilter = [];
  projectSelected = [];
  projects = [];

  typeReport = 'day';
  typeReportFilter = 'day';
  typeSentimentPost = 'neg';
  typeSentimentEdit = 'neg';
  dtOptions: DataTables.Settings = {};
  listPosts = [];
  keywords = '';
  dataList = [];
  dataTableShow = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;

  negPost = '';
  posPost = '';
  neuPost = '';
  currentSentiment = null;
  showSuggestPost = false;
  ckeditorContent = ``;
  arrayPost = [];
  
  typeAction = 'create';
  notSpam = true;

  
  pageSizeRecommand = 15;
  currentPageRecommand = 1;
  totalRecommandPost = 15;

   daterange: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };

   dateRangeRecommand: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };

  daterangeFilter: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };




   selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    

    this.optionsRecommand.startDate = value.start;
    this.optionsRecommand.endDate = value.end;

    this.dateRangeRecommand.start = value.start;
    this.dateRangeRecommand.end = value.end;

    this.options.startDate = this.daterange.start;
    this.options.endDate =  this.daterange.end;
  }

  selectedDateFilter(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
  }

   selectedDate1(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.dateRangeRecommand.start = value.start;
    this.dateRangeRecommand.end = value.end;
  }


  options = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };
  optionsRecommand = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.dateRangeRecommand.start,
    endDate: this.dateRangeRecommand.end
  };

  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };

  selectedProjects = [];

  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private sentimentReportService: SentimentReportsService,
    private modalService: BsModalService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: true,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      singleSelection: false,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
    
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [1, 2], 'searchable': true }
      ]
    };
  };
 
   resolveAfter1Seconds() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve('resolved');
      }, 1000);
    });
  }
  
  checkExitsRecommand(item) {
    let check = false;
    for (var i = 0; i < this.arrayPost.length; i++) {
      if (this.arrayPost[i].item._id == item["_source"]["docId"]) {
        check = true;
        break;
      }
    }
    return check;
  }
  clickRemoveRecommand(item) {
    for (var i = 0; i < this.arrayPost.length; i++) {
      if (this.arrayPost[i].item._id == item["_source"]["docId"]) {
        this.arrayPost.splice(i, 1);
        break;
      }
    }
  }
  clickSaveRecommand(item) {
    this.arrayPost.push({
      type : this.typeSentimentPost,
      item : item
    });
  }

  
  async savePosts() {

    this.negPost = '';
    this.neuPost = '';
    this.posPost = '';
    this.arrayPost.forEach(post => {
      switch (post.type) {
        case 'neg':
          if (this.dataReport) {
           this.negPost +=  `${post.item._source.message}<br>`;
          }
         break;
        case 'neu':
          if (this.dataReport) {
            this.neuPost +=  `${post.item._source.message}<br>`;
          }
          break;
        case 'pos':
          if (this.dataReport) {
            this.posPost +=  `${post.item._source.message}<br>`;
          }
          break;
        default:
          break;
      }
    })
    this.dataReport = {};
 
    // let await1s = await this.resolveAfter1Seconds()
   
    this.dataReport = {
      report_desc: "Báo cáo sắc thái bài viết",
      report_type: this.typeReport,
      report_name: "Báo cáo sắc thái từ ngày " + this.daterange.start.format('DD/MM/YYYY') + " đến ngày " + this.daterange.end.format('DD/MM/YYYY'),
      report_project: this.projectSelected,
      report_brand: this.brandSelected,
      report_start_date: new Date(this.daterange.start.valueOf()),
      report_end_date: new Date(this.daterange.end.valueOf()),
      report_code: "BCST",
      data: {
        sentiment:  this.currentSentiment,
        negPost: this.negPost,
        posPost: this.posPost,
        neuPost: this.neuPost,
      }
    };
    this.modalRef.hide();
  }

  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }


  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });
  }

  getDataFromServer() {
    this.dataTableShow = false;
    this.sentimentReportService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {
        
    let filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      typeReport: this.typeReportFilter,
      report_code: ["BCST"]
    };
    this.dataTableShow = false;
    this.dataList = [];
    this.sentimentReportService.getAllReportManager(filter).subscribe(response => {
      this.dataList = response.data;
      this.dataTableShow = true;
    });
  }

  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  viewPost() {
    this.showSuggestPost = false;
    if (this.projectSelected.length == 0 && this.brandSelected.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }
    const filter2 = {
      filter : {
        gte: this.dateRangeRecommand.start.valueOf(),
        lte: this.dateRangeRecommand.end.valueOf()
      },
      projects: this.projectSelected,
      brands: this.brandSelected,
      size: this.pageSizeRecommand,
      from: (this.currentPageRecommand -1) * this.pageSizeRecommand,
      typeSentimentPost: this.typeSentimentPost,
      notSpam : this.notSpam,
      type: 'facebook'
    };
    this.sentimentReportService.getSuggestionPost(filter2).subscribe(res => {
      if (res.success) {
        this.showSuggestPost = true;
        this.totalRecommandPost = res.data.hits.total.value < (10000 - this.pageSizeRecommand) ? res.data.hits.total.value : (10000 - this.pageSizeRecommand);
        this.listPosts = res.data.hits.hits;
      }

    })
  }

  clickReport() {
    if (this.projectSelected.length == 0 && this.brandSelected.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }

    // let timeRange = Math.ceil((this.daterange.end.valueOf() - this.daterange.start.valueOf()) / (24 * 60 * 60 * 1000));
    // if (timeRange > 60) {
    //   this.toastrService.warning("Khoảng thời gian chọn không được quá 60 ngày!", "Thông báo!");
    //   return;
    // }
    
    this.dataReport = {};
    this.arrayPost = [];
    let filter = {
      from: this.daterange.start.valueOf(),
    
        gte: this.daterange.start.valueOf(),
        lte: this.daterange.end.valueOf(),
    

      projects: this.projectSelected,
      brands: this.brandSelected,
      type: this.typeReport,
      notSpam: this.notSpam2
    };
    this.sentimentReportService.getReport({ filter: filter, index: "full" }).subscribe(response => {
      let data = response.data;
      if (data) {
        let aggregations = data.aggregations;
        //sac thai
        let sentimentsCount = aggregations.dataFilter.sentimentsCount.statistic.seg.buckets;
        let sentiment = {};
        for (var i = 0; i < sentimentsCount.length; i++) {
          sentiment[sentimentsCount[i].key] = sentimentsCount[i].doc_count;
        }

        this.currentSentiment = JSON.parse(JSON.stringify(sentiment));
   
        this.dataReport = {
          report_desc: "Báo cáo sắc thái thảo luận",
          report_type: this.typeReport,
          report_name: "Báo cáo sắc thái thảo luận từ ngày " + this.daterange.start.format('DD/MM/YYYY') + " đến ngày " + this.daterange.end.format('DD/MM/YYYY'),
          report_project: this.projectSelected,
          report_brand: this.brandSelected,
          report_start_date: new Date(this.daterange.start.valueOf()),
          report_end_date: new Date(this.daterange.end.valueOf()),
          report_code: "BCST",
          data: {
            sentiment:  this.currentSentiment,
            negPost: '',
            posPost: '',
            neuPost: '',
          }
        }
      }
    });

  }
  onCkEditorChange(item) {
    this.ckeditorContent = item.toString();
  }

  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }

      this.dataReport["report_title"] = this.reportName.trim();
      this.sentimentReportService.createReportManager(this.dataReport).subscribe(response => {

        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.dataReport = {};
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
        this.arrayPost = [];

      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }

  showRecommentPost(modalRef) {
    this.viewPost()
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal-1'
    });
  }

  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }

  clickEditReportItem(item,modalRef) {
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
    this.typeSentimentEdit = 'neg';
    this.ckeditorContent = this.currentConfigItem['data'].negPost
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg'
    });
  }

  onTypeSentimentEditChange(type) {
    if(type == 'neg') {
      this.ckeditorContent = this.currentConfigItem['data'].negPost
    }
    if(type == 'neu') {
      this.ckeditorContent = this.currentConfigItem['data'].neuPost
    }
    if(type == 'pos') {
      this.ckeditorContent = this.currentConfigItem['data'].posPost
    }
  }

  saveEditPost(){
    if(this.typeSentimentEdit == 'neg') {
       this.currentConfigItem['data'].negPost =  this.ckeditorContent;
    }
    if(this.typeSentimentEdit == 'neu') {
      this.currentConfigItem['data'].neuPost =  this.ckeditorContent;
    }
    if(this.typeSentimentEdit == 'pos') {
     this.currentConfigItem['data'].posPost =  this.ckeditorContent;
    }
    this.sentimentReportService.updateReport(this.currentConfigItem['_id'], this.currentConfigItem['data']).subscribe(res => {

      if(res.success){
        this.toastrService.success('Update thành công','Thông báo');
        this.modalRef.hide();
        this.getReportManager();
        this.dataReport = null;
        this.dataReport = this.currentConfigItem;
      }
    });
  }

  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef = this.modalService.show(modalRef);
  }

  deleteReport() {
    this.sentimentReportService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
    this.modalRef2.hide();
  }
  pageChange(number) {
    this.listPosts = [];
    this.currentPageRecommand = number;
    this.viewPost();
 }

  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/sentiment-report/sentiment-reports.component.ts